<template>
  <div>
    <ActionBar
      :checkedItems="checkedItems"
      :isOrders="true"
      @done="actionDone"
      add
      del
      @getDataSearch="getDataSearch"
      :listTransportTotalRequest="listTransportTotalRequest"
    />
    <b-field>
      <b-icon icon="question-circle" size="is-medium" class="v-link-icon">
      </b-icon>
      <a
        href="https://docs.google.com/presentation/d/1JfTigPdYyNgBPu5jnyeQ_vxgqLFp2pYz5HKKUgG4vmI/edit#slide=id.g13cf4675eca_0_0"
        target="_blank"
        class="v-link-content"
        >業販・ワンプラ購入の場合
      </a>
    </b-field>
    <ItemTableList
      ref="list"
      checkable
      :items="filteredItems"
      :isBooked="false"
      :isOrders="true"
      @item-click="itemClick"
      @onUpdateCheckedItems="onUpdateCheckedItems"
    />
  </div>
</template>
<style scoped>
.v-link-icon {
  margin-top: 12px;
  color: #bf9000;
  width: 20px;
  height: 15px;
}
.v-link-content {
  color: #0777c5;
  font-weight: 500;
  font-size: 15px;
  text-decoration: underline;
  margin-top: 10px;
  margin-left: 3px;
}
.v-link-content:hover {
  color: #a260d8;
}
</style>
<script>
import _debounce from 'lodash/debounce';
import jcPackage from '@/repositories/jcPackage';
export default {
  data: () => ({
    checkedItems: [],
    filteredItems: [],
    customerId: '',
    customerName: '',
    listMatterNo: [],
    listTransportTotalRequest: null,
  }),
  components: {
    ItemTableList: () => import('@/components/ItemTableList'),
    ActionBar: () => import('@/components/ActionBar.vue'),
  },
  async created() {

    this.debounceFilter = _debounce(this.filter, 300);
    this.$watch(
      () => [this.items, this.customerName, this.customerId],
      () => this.debounceFilter()
    );
    await this.getData();
  },
  methods: {
    filter() {
      this.filteredItems = this.items.filter(
        (item) => this.filterCustomerId(item) && this.filterCustomerName(item)
      );
    },
    getDataSearch(data) {
      this.customerId = data.customerId;
      this.customerName = data.customerName;
    },
    filterCustomerName(item) {
      return (
        item.customerName
          .trim()
          .toLowerCase()
          .replaceAll(' ', '')
          .indexOf(
            this.customerName.trim().toLowerCase().replaceAll(' ', '')
          ) >= 0
      );
    },
    filterCustomerId(item) {
      return (
        item.customerId
          .trim()
          .toLowerCase()
          .replaceAll(' ', '')
          .indexOf(this.customerId.trim().toLowerCase().replaceAll(' ', '')) >=
        0
      );
    },
    getData() {
      this.items = this.$store.getters.incompleteItems;
      this.$store.commit('setOrdersCount', this.items.length);
      if (this.$store.getters.transportVendorsWithItems[0]) {
        this.filterDate(
          this.$store.getters.transportVendorsWithItems[0].items,
          this.items
        );
      }
      this.filteredItems = this.items;

      this.items.map((item) => {
        if (item.matterNo && item.matterNo != '') {
          this.listMatterNo.push(item.matterNo);
        }
      });
      const listTransportTotalRequestApi = jcPackage.getListTransportOderByMatterNo(
        this.$store.state.accessTokenJPC,
        this.listMatterNo
      );
      listTransportTotalRequestApi.then((rs) => {
        this.listTransportTotalRequest = rs.data;
      });
    },
    filterDate(data, items) {
      let arrayIndex = [];
      let arrayData = [];
      data.map((x) => {
        this.items.map((y, index) => {
          if (x.vinNo == y.vinNo && x.transportFromId == y.transportFromId) {
            arrayIndex.push(index);
          }
        });
      });
      this.items.map((x, index) => {
        let a = arrayIndex.indexOf(index);
        if (a < 0) {
          arrayData.push(x);
        }
      });
      this.items = [...arrayData];
      this.$store.commit('setOrdersCount', this.items.length);
    },
    onUpdateCheckedItems(props) {
      this.checkedItems = props.items;
    },
    itemClick(p) {
      this.$store.commit('setItemsInList', p.items);
      this.$router.push({
        name: 'item',
        params: {
          id: p.item.id,
          isBookedItem: false,
          isOrder: true,
        },
      });
    },
    async actionDone(props) {
      await this.$store.dispatch('fetchOrdersAndBookingItems');
      if (props && props.id) {
        this.$router.push({
          name: 'item',
          params: {
            id: props.id,
          },
        });
        return false;
      } 
      //this.$refs.list.$data.checkedItems = this.checkedItems = [];
    },
  },
};
</script>
